<template>
  <template-info :bgImg="bgImg" title="มีเรื่องอะไรควรรู้อีกบ้าง">
    <div>
      <div class="csb-detail">
        ไหนๆ ก็ขายดีจนต้องจด VAT ไปจดจัดตั้งบริษัทหรือ
        ห้างหุ้นส่วนจำกัดเลยแล้วกัน
      </div>

      <div class="csb-detail">
        <span>สิ่งที่ต้องทำ</span> <br />
        หาผู้ทำบัญชีมาจัดทำบัญชี และออกงบการเงิน
        งบการเงินต้องตรวจสอบโดยผู้ตรวจสอบบัญชี ยื่นงบการเงิน ภายใน 5
        เดือนหลังจากปิดรอบปีบัญชี ซึ่งปัจจุบันทำบนระบบออนไลน์ได้เลย
      </div>
    </div>
  </template-info>
</template>

<script>
import BackgroundImg from "@/assets/images/infos/corp_suggestion.png";

export default {
  name: "CorpSuggestion",
  components: {},
  data() {
    const bgImg = BackgroundImg;
    return {
      bgImg: bgImg,
    };
  },
};
</script>

<style scoped>
.csb-detail {
  width: 100%;
  color: #393d43;
  margin-bottom: 20px;
  text-align: left;
}
.csb-detail > span {
  font-weight: bold;
}
</style>
